import React from "react";
const IconClickCollect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none" {...props}>
    <path
      d="M19.9444 17.4894C19.9444 11.7213 23.7252 8 28.3889 8C33.0526 8 36.8333 11.7213 36.8333 17.4894M26.5295 40.0897L27.809 38.8434M26.3099 33.8586H24.5004M28.2355 29.2892L26.956 28.043M33.0304 27.3131V25.5507M38.0452 28.8738L39.3247 27.6276M43.1687 37.3171L31.2211 32.197L36.6098 44.6435M43.1687 37.3171L49.5 40.0303L44.7189 42.3091L49.2101 46.6958L46.0948 49.7301L41.6035 45.3433L39.2638 50L36.6098 44.6435M43.1687 37.3171C43.8776 30.4782 44.4362 25.6084 45.2778 17.4894H11.5L14.3148 44.6435H36.6098"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconClickCollect;
